import { corr, corr2 } from './mhahInterfaces';

export class MhahMoonOutragConst {
  //---------------------------------------------------------------------------
  // Data on the Moon outrage in length.
  //---------------------------------------------------------------------------

  corrMoon = [
    new corr(0, 0, 0, 4, 13.902),
    new corr(0, 0, 0, 2, 2369.912),
    new corr(1, 0, 0, 4, 1.979),
    new corr(1, 0, 0, 2, 191.953),
    new corr(1, 0, 0, 0, 22639.5),
    new corr(1, 0, 0, -2, -4586.465),
    new corr(1, 0, 0, -4, -38.428),
    new corr(1, 0, 0, -6, -0.393),
    new corr(0, 1, 0, 4, -0.289),
    new corr(0, 1, 0, 2, -24.42),
    new corr(0, 1, 0, 0, -668.146),
    new corr(0, 1, 0, -2, -165.145),
    new corr(0, 1, 0, -4, -1.877),
    new corr(0, 0, 0, 3, 0.403),
    new corr(0, 0, 0, 1, -125.154),
    new corr(2, 0, 0, 4, 0.213),
    new corr(2, 0, 0, 2, 14.387),
    new corr(2, 0, 0, 0, 769.016),
    new corr(2, 0, 0, -2, -211.656),
    new corr(2, 0, 0, -4, -30.773),
    new corr(2, 0, 0, -6, -0.57),
    new corr(1, 1, 0, 2, -2.921),
    new corr(1, 1, 0, 0, -109.673),
    new corr(1, 1, 0, -2, -205.962),
    new corr(1, 1, 0, -4, -4.391),
    new corr(1, -1, 0, 4, 0.283),
    new corr(1, -1, 0, 2, 14.577),
    new corr(1, -1, 0, 0, 147.687),
    new corr(1, -1, 0, -2, 28.475),
    new corr(1, -1, 0, -4, 0.636),
    new corr(0, 2, 0, 2, -0.189),
    new corr(0, 2, 0, 0, -7.486),
    new corr(0, 2, 0, -2, -8.096),
    new corr(0, 0, 2, 2, -5.741),
    new corr(0, 0, 2, 0, -411.608),
    new corr(0, 0, 2, -2, -55.173),
    new corr(0, 0, 2, -4, 0.025),
    new corr(1, 0, 0, 1, -8.466),
    new corr(1, 0, 0, -1, 18.609),
    new corr(1, 0, 0, -3, 3.215),
    new corr(0, 1, 0, 1, 18.023),
    new corr(0, 1, 0, -1, 0.56),
    new corr(3, 0, 0, 2, 1.06),
    new corr(3, 0, 0, 0, 36.124),
    new corr(3, 0, 0, -2, -13.193),
    new corr(3, 0, 0, -4, -1.187),
    new corr(3, 0, 0, -6, -0.293),
    new corr(2, 1, 0, 2, -0.29),
    new corr(2, 1, 0, 0, -7.649),
    new corr(2, 1, 0, -2, -8.627),
    new corr(2, 1, 0, -4, -2.74),
    new corr(2, -1, 0, 2, 1.181),
    new corr(2, -1, 0, 0, 9.703),
    new corr(2, -1, 0, -2, -2.494),
    new corr(2, -1, 0, -4, 0.36),
    new corr(1, 2, 0, 0, -1.167),
    new corr(1, 2, 0, -2, -7.412),
    new corr(1, 2, 0, -4, -0.311),
    new corr(1, -2, 0, 2, 0.757),
    new corr(1, -2, 0, 0, 2.58),
    new corr(1, -2, 0, -2, 2.533),
    new corr(0, 3, 0, -2, -0.344),
    new corr(1, 0, 2, 2, -0.992),
    new corr(1, 0, 2, 0, -45.099),
    new corr(1, 0, 2, -2, -0.179),
    new corr(1, 0, -2, 2, -6.382),
    new corr(1, 0, -2, 0, 39.528),
    new corr(1, 0, -2, -2, 9.366),
    new corr(0, 1, 2, 0, 0.415),
    new corr(0, 1, 2, -2, -2.152),
    new corr(0, 1, -2, 2, -1.44),
    new corr(0, 1, -2, -2, 0.384),
    new corr(2, 0, 0, 1, -0.586),
    new corr(2, 0, 0, -1, 1.75),
    new corr(2, 0, 0, -3, 1.225),
    new corr(1, 1, 0, 1, 1.267),
    new corr(1, -1, 0, -1, -1.089),
    new corr(0, 0, 2, -1, 0.584),
    new corr(4, 0, 0, 0, 1.938),
    new corr(4, 0, 0, -2, -0.952),
    new corr(3, 1, 0, 0, -0.551),
    new corr(3, 1, 0, -2, -0.482),
    new corr(3, -1, 0, 0, 0.681),
    new corr(2, 0, 2, 0, -3.996),
    new corr(2, 0, 2, -2, 0.557),
    new corr(2, 0, -2, 2, -0.459),
    new corr(2, 0, -2, 0, -1.298),
    new corr(2, 0, -2, -2, 0.538),
    new corr(1, 1, -2, -2, 0.426),
    new corr(1, -1, 2, 0, -0.304),
    new corr(1, -1, -2, 2, -0.372),
    new corr(0, 0, 4, 0, 0.418),
    new corr(2, -1, 0, -1, -0.352),
  ];

  // l, ml, ms, f, d
  //corrMoon2 = new Array(); // additional

  corrMoon2 = [
    new corr2(0.127, 0, 0, 0, 6),
    new corr2(-0.151, 0, 2, 0, -4),
    new corr2(-0.085, 0, 0, 2, 4),
    new corr2(0.15, 0, 1, 0, 3),
    new corr2(-0.091, 2, 1, 0, -6),
    new corr2(-0.103, 0, 3, 0, 0),
    new corr2(-0.301, 1, 0, 2, -4),
    new corr2(0.202, 1, 0, -2, -4),
    new corr2(0.137, 1, 1, 0, -1),
    new corr2(0.233, 1, 1, 0, -3),
    new corr2(-0.122, 1, -1, 0, 1),
    new corr2(-0.276, 1, -1, 0, -3),
    new corr2(0.255, 0, 0, 2, 1),
    new corr2(0.254, 0, 0, 2, -3),
    new corr2(-0.1, 3, 1, 0, -4),
    new corr2(-0.183, 3, -1, 0, -2),
    new corr2(-0.297, 2, 2, 0, -2),
    new corr2(-0.161, 2, 2, 0, -4),
    new corr2(0.197, 2, -2, 0, 0),
    new corr2(0.254, 2, -2, 0, -2),
    new corr2(-0.25, 1, 3, 0, -2),
    new corr2(-0.123, 2, 0, 2, 2),
    new corr2(0.173, 2, 0, -2, -4),
    new corr2(0.263, 1, 1, 2, 0),
    new corr2(0.13, 3, 0, 0, -1),
    new corr2(0.113, 5, 0, 0, 0),
    new corr2(0.092, 3, 0, 2, -2),
  ];
}
